/**
@fileoverviewThis component contains the modal for acknowledging the new terms and conditions on the qBraid platform.
@description The AcknowledgeNewTerms component includes:
- The modal for acknowledging the new terms and conditions
- The agree and disagree buttons
- The functionality for the agree and disagree buttons
@todo
Add tests for the modal visibility
Add tests for the agree and disagree buttons
Copyright (C) 2024 qBraid Development Team 
*/

import Swal from 'sweetalert2';
import {
	Button, Link, Grid, Modal, Typography 
} from '@mui/material';
import { useDispatch } from 'react-redux';
import LoginSurveyImage from '../../assets/images/LogInSurvey.jpg';
import QbraidLogo from '../../assets/images/qbraid_full_logo.png';
import { LAB_URL, axiosClient } from '../../utils/axiosClient';
import { UserLogoutFunction } from '../../Redux/Action/userAction';
import './index.css';

function AcknowledgeNewTerms({ openTermsModal, setOpenTermsModal }) {
	const dispatch = useDispatch();
	const handleAgree = () => {
		axiosClient()
			.get('/api/user/acknowledge-terms')
			.then((_data) => {
				setOpenTermsModal(false);
				Swal.fire('Thank you and welcome back to qBraid!');
			})
			.catch((_err) => {
				// eslint-disable-next-line
				// eslint-disable-next-line no-console
				setOpenTermsModal(false);
				Swal.fire('Sorry Something went wrong');
			});
	};
	const handleDisagree = () => {
		setOpenTermsModal(false);
		dispatch(UserLogoutFunction()).then(() => {
			window.open(`${LAB_URL}/hub/home?accountLogout`, '_blank');
		});
		Swal.fire({
			title: 'You have been logged out 🤧',
			text: 'Log back in and accept the updated terms to continue',
			confirmButtonColor: 'var(--brand-color-1)',
			reverseButtons: true,
			inputAttributes: {
				id: 'confirm-logout'
			}
		}).then((_res) => {
			window.location.reload();
		});
	};
	return (
		<Modal
			open={openTermsModal}
			sx={{
				display: 'flex',
				justifyContent: 'center',
				alignItems: 'center',
				padding: '1em'
			}}
			disableEscapeKeyDown
		>
			<Grid container className="modal_outer_container">
				<Grid
					item
					xs={12}
					sm={12}
					md={12}
					lg={12}
					xl={12}
					className="modal_right_container"
				>
					<Grid container gap={5}>
						<Grid item xs={12} marginBottom="1rem">
							<img
								src={QbraidLogo}
								alt="qBraid Logo"
								className="right_logo"
								cy-data="ack-domain-logo"
							/>
						</Grid>
						<Grid item xs={12}>
							<img
								src={LoginSurveyImage}
								alt="Login_Survey_Image"
								className="login_survey_image"
								cy-data="ack-survey-img"
							/>
						</Grid>
						<Grid item xs={12}>
							<Typography className="right_sub_2" cy-data="ack-desc">
								Hey there, we have made some changes to our terms and
								conditions. Click agree to continue using qBraid.
							</Typography>
						</Grid>
						<Grid
							item
							container
							xs={12}
							sx={{
								display: 'flex',
								justifyContent: 'center',
								alignItems: 'center',
								gap: '1em'
							}}
						>
							<Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
								<Button
									fullWidth
									onClick={() => handleAgree()}
									variant="slide"
									cy-data="ack-agree-btn"
								>
									Agree
								</Button>
							</Grid>
							<Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
								<Button
									fullWidth
									variant="slide"
									color="error"
									onClick={() => handleDisagree()}
									cy-data="ack-disagree-btn"
								>
									Disagree
								</Button>
							</Grid>
						</Grid>

						<Grid item xs={12}>
							<Typography className="right_sub_2" cy-data="ack-tex-links">
								Learn more about our updates for our
								<Link
									color="#2E3338"
									className="linktext"
									aria-label="Terms & Conditions opens in new tab"
									target="_blank"
									href="/terms-and-conditions"
								>
									Terms & Conditions,
								</Link>
								<Link
									color="#2E3338"
									className="linktext"
									aria-label="Privacy Policy opens in new tab"
									target="_blank"
									href="/privacy-policy"
								>
									Privacy Policy
								</Link>
								and
								<Link
									color="#2E3338"
									aria-label="Cookie Policy opens in new tab"
									target="_blank"
									href="/cookie-policy"
									className="linktext"
								>
									Cookie Policy.
								</Link>
							</Typography>
						</Grid>
					</Grid>
				</Grid>
			</Grid>
		</Modal>
	);
}

export default AcknowledgeNewTerms;
